import { GET_INTERNAL_AUDIT_DATA_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const getInternalAuditDataAPI = async (): Promise<any[]> => {
    const response = await axios.get(GET_INTERNAL_AUDIT_DATA_API);
    return response.data;
};
